import { render, staticRenderFns } from "./rsvp-form.vue?vue&type=template&id=63fa8542&scoped=true&"
import script from "./rsvp-form.vue?vue&type=script&lang=js&"
export * from "./rsvp-form.vue?vue&type=script&lang=js&"
import style0 from "./rsvp-form.vue?vue&type=style&index=0&id=63fa8542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fa8542",
  null
  
)

export default component.exports